module.exports = __webpack_public_path__ + "fonts/Chivo-Black.b0cc269.ttf";